"use client";

import React, { createRef, ReactNode } from "react";
import Styles from "./NSBoxBoolean.module.css";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IValidationProps } from "../props/IValidationProps";
import { safeMenuMenuItem } from "./NSMenuButton";
import { INSBoxBaseLayoutProps, NSBoxBaseLayout } from "./NSBoxBaseLayout";
import { Validator } from "../Validator";
import { INSBox } from "./INSBox";

export interface NSBoxBooleanProps extends IBaseComponentProps, IValidationProps, INSBoxBaseLayoutProps<NSBoxBoolean, boolean>
{
	checked?: (boolean | null);
	label?: IBaseComponentProps;
	input?: IBaseComponentProps;
	children?: ReactNode;
}

export interface NSBoxBooleanState
{
	value: boolean | null;
}

export class NSBoxBoolean extends React.Component<NSBoxBooleanProps, NSBoxBooleanState> implements INSBox
{
	private _isdirtied: boolean = false;
	NSBoxBaseLayout_Main = createRef<NSBoxBaseLayout>();
	constructor(props: NSBoxBooleanProps)
	{
		super(props);
		this.state = { value: props.checked ?? props.defaultValue ?? false };
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
		this.getValueNull = this.getValueNull.bind(this);
		this.setValueNull = this.setValueNull.bind(this);
	}
	getError(): string | null
	{
		return (
			Validator.getError(this.props.title, this.state.value, this.props)
		);
	}
	getValue(checkError: boolean = true): boolean | null
	{
		if (this.props.required)
			return this.getValueBool(checkError);
		return this.getValueNull(checkError);
	}
	setValue(value: boolean | null, callback?: () => void): void
	{
		this.setValueNull(value, callback);
	}
	getValueBool(checkError: boolean = true): boolean
	{
		if (!this.props.required)
			throw new Error("Please call getValue or getValueNull function");
		return NSBoxBaseLayout.checkGetValue(this, checkError, () => this.state.value) ?? false;
	}
	setValueBool(value: boolean, callback?: () => void): void
	{
		this.setValueNull(value, callback);
	}
	getValueNull(checkError: boolean = true): boolean | null
	{
		if (this.props.required)
			throw new Error("Please call getValue or getValueBool function");
		return NSBoxBaseLayout.checkGetValue(this, checkError, () => this.state.value);
	}
	setValueNull(value: boolean | null, callback?: () => void): void
	{
		this.setState({ value }, () =>
		{
			this.props.onChanged?.(this);
			callback?.();
		});
	}
	isEmpty(): boolean
	{
		return !this._isdirtied;
	}
	override componentDidUpdate(prevProps: Readonly<NSBoxBooleanProps>): void
	{
		if (prevProps.checked !== this.props.checked)
			if (this.props.checked !== undefined)
				this.setValueNull(this.props.checked);
	}
	override componentDidMount(): void
	{
		this.props.onChanged?.(this);
	}
	override render()
	{
		let menu = safeMenuMenuItem(this.props, () => { });

		return (
			<NSBoxBaseLayout
				ref={this.NSBoxBaseLayout_Main}
				{...this.props}
				title=""
				menu={menu}
			>
				<label
					id={this.props.label?.id}
					className={`ns-font-16-normal ${Styles.ns_box_boolean_label} ${this.props.label?.classList?.join(" ") ?? ""}`}
					style={this.props.label?.style}
					htmlFor={this.props.name}
				>
					<input
						id={this.props.input?.id}
						name={this.props.input?.name}
						type="checkbox"
						className={`${Styles.ns_box_boolean_input} ${this.state.value == null ? Styles.ns_box_boolean_indeterminate : ""} ${this.props.input?.classList?.join(" ") ?? ""}`}
						checked={this.state.value ?? false}
						onChange={e => this.setValue(e.target.checked)}
						onClick={() => { this.props.onClicked?.(this); }}
						style={this.props.input?.style}
					/>
					<span style={{ width: "0px" }}></span>
					{this.props.hideHeader && this.props.required && <span style={{ color: "red" }}>*</span>}
					{this.props.title}
					{this.props.children}
				</label>
			</NSBoxBaseLayout>
		);
	}
}